import { memo, useMemo } from "react";
import Microsoft from "../../../../assets/images/partners/Microsoft.png";
import MicrosoftAzure from "../../../../assets/images/partners/Microsoft_Azure_Logo.png";
import Sypnology from "../../../../assets/images/partners/Synology.png";
import ThreeCX from "../../../../assets/images/partners/3cx.png";
import DigitalOcean from "../../../../assets/images/partners/DigitalOcean.png";
import CrazyDomains from "../../../../assets/images/partners/Crazydomain.png";
import { Sparkles } from "lucide-react";

interface Logo {
    name: string;
    url?: string;
    isText?: boolean;
}

const LOGOS: Logo[] = [
    { name: "Microsoft", url: Microsoft },
    { name: "Microsoft Azure", url: MicrosoftAzure },
    { name: "Synology", url: Sypnology },
    { name: "VoIP Service", url: ThreeCX },
    { name: "DigitalOcean", url: DigitalOcean },
    { name: "CrazyDomains", url: CrazyDomains },
    { name: "SAN telco", isText: true },
    { name: "SAN domains", isText: true },
];

const AffiliationsCarousel = () => {
    const displayLogos = useMemo(() => [...LOGOS, ...LOGOS], []);

    return (
        <div className="relative w-full h-full flex flex-col justify-center overflow-hidden pt-16 pb-12 md:py-20 md:px-24 xl:px-0">
            {/* Gradient Accents */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 -left-32 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" />
                <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
            </div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                {/* Header */}
                <div className="text-center mb-10 md:mb-14">
                    <div className="inline-flex items-center gap-2.5 px-5 py-2.5 mb-6 bg-white/5 rounded-full border border-white/10">
                        <Sparkles className="w-4 h-4 text-cyan-400" />
                        <span className="text-xs md:text-sm font-semibold text-gray-300 tracking-widest uppercase">
                            Trusted Partners
                        </span>
                    </div>

                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight tracking-tight">
                        World-Class
                        <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent pl-2">
                            Collaborations
                        </span>
                    </h2>

                    <p className="text-base md:text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed font-light">
                        Empowered by industry leaders to deliver cutting-edge solutions
                    </p>
                </div>

                {/* CSS Infinite Scroll Carousel */}
                <div className="relative overflow-hidden group/carousel">
                    <div className="flex gap-12 sm:gap-16 w-max animate-scroll-logos group-hover/carousel:pause">
                        {displayLogos.map((logo, index) => (
                            <div key={index} className="group flex-shrink-0 relative">
                                <div className="relative bg-transparent border border-transparent rounded-2xl p-6 sm:p-8 w-56 sm:w-64 h-36 sm:h-44 flex items-center justify-center transition-all duration-500 hover:border-white/10 hover:bg-white/5">
                                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-cyan-500/0 via-blue-500/0 to-purple-400/0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 blur-xl" />
                                    {logo.isText ? (
                                        <div className="relative z-10 text-center">
                                            <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent transition-all duration-500 group-hover:scale-110">
                                                {logo.name}
                                            </h3>
                                        </div>
                                    ) : (
                                        <img
                                            src={logo.url}
                                            alt={logo.name}
                                            className="relative z-10 max-h-20 sm:max-h-24 w-auto object-contain opacity-90 transition-all duration-500 group-hover:opacity-100 group-hover:scale-110"
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes scroll-logos {
                    0% { transform: translate3d(0, 0, 0); }
                    100% { transform: translate3d(-50%, 0, 0); }
                }
                .animate-scroll-logos {
                    animation: scroll-logos 60s linear infinite;
                    will-change: transform;
                    display: flex;
                }
                .pause {
                    animation-play-state: paused !important;
                }
            `}</style>
        </div>
    );
};

export default memo(AffiliationsCarousel);